<template>
    <div style="font-size: 14px;width: 100%">
        <v-layout row class="ma-0">
            <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">位置</div>
            <div style="width: 180px;height: 20px;margin-left: 17px">
                <v-text-field
                        maxLength="30"
                        v-model="editAddrText"
                        class="jumpTextField"
                        background-color="rgba(56, 56, 56, 1)"
                        style="font-size: 14px;color: white;width: 180px"
                        dark
                        dense
                        height="20"
                        @blur="blurEditAddrText()"
                >
                    <template v-slot:append>
                        <div style="font-size: 12px;color: rgba(128, 128, 128, 1);margin-top: 4px">{{editAddrText.length}}/30</div>
                    </template>
                </v-text-field>
            </div>
        </v-layout>
        <v-layout row class="ma-0" style="margin-top: 6px;">
            <div style="width: 60px"></div>
            <div style="color: white;line-height: 21px;color: rgba(166, 166, 166, 1);font-size: 12px;width: 170px;margin-left: 17px">
                {{country}}
            </div>
        </v-layout>

    </div>
</template>

<script>
    export default {
        name: "LocationEditor",
        props:["currAddrName","country","addrIndex"],
        data(){
            return{
                editAddrText:this.currAddrName,
            }
        },
        methods:{
            blurEditAddrText(){
                let temp={
                    index:this.addrIndex,
                    addr:this.editAddrText
                }
                this.$emit("changeAddrName",temp)
            },
            editAddr(val){
                this.isEditAddr = true
                this.editAddrText = val
            },
        }
    }
</script>

<style >
    .jumpTextField .v-input__slot{
        min-height: 20px !important;
        padding: 0 !important;
        margin: 0 !important;
    }
    .v-text-field{
        margin-top: 0 !important;
    }
</style>
